module.exports = __webpack_public_path__ + "images/videoCaseStudy-urbanPartnershipBank-results-photo-02.jpg?h=8b84aa71aecf32b0c8fcabad24ddd782";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/videoCaseStudies/urbanPartnershipBank/videoCaseStudy-urbanPartnershipBank-results-photo-02.jpg
// module id = 2127
// module chunks = 12 15